import { formatDate } from '@mc/react-format';
import { mcCalendar } from '@mc/react-ui-icons';
import { Card, Block, Title, Space, Tag, Icon, Text } from '@mc/ui-v4';
import React from 'react';
import { getEtapa } from '../helpers/mapioHelpers';
import { ValueRange } from './ValueRange';
export const EtapaDetail = ({ activeInfo, etapaIndex }) => {
    var _a;
    const etapa = getEtapa(activeInfo, etapaIndex);
    if (!etapa) {
        return null;
    }
    return (React.createElement(Card, { mode: 'view' },
        React.createElement(Block, null,
            React.createElement("div", null,
                React.createElement(Title, { type: 'card', extra: React.createElement(Space, null,
                        (etapa === null || etapa === void 0 ? void 0 : etapa.plocha) ? (React.createElement(Tag, { color: 'purple' },
                            etapa.plocha,
                            " m",
                            React.createElement("sup", null, "2"))) : null,
                        (etapa === null || etapa === void 0 ? void 0 : etapa.pocetDni) ? React.createElement(Tag, { color: 'blue' },
                            etapa.pocetDni,
                            " dn\u00ED") : null), extraLeft: true }, "Informace o etap\u011B")),
            React.createElement(Space, { className: 'mt-1', size: '1', vertical: true }, (_a = etapa === null || etapa === void 0 ? void 0 : etapa.obdobi) === null || _a === void 0 ? void 0 : _a.map((období, index) => {
                const periodId = `periode-${index}`;
                return React.createElement(PeriodRow, { key: periodId, obdobi: období });
            })),
            (etapa === null || etapa === void 0 ? void 0 : etapa.duvod) ? (React.createElement(Card, { className: 'mt-1', mode: 'section' },
                React.createElement(Block, null,
                    React.createElement(Title, { type: 'block' }, "Zp\u016Fsob realizace"),
                    React.createElement(Text, null, etapa.duvod)))) : null)));
};
const PeriodRow = ({ obdobi }) => {
    var _a, _b;
    return (React.createElement("div", { className: 'd-flex align-items-center', style: { gap: 7 } },
        React.createElement(Icon, { icon: mcCalendar }),
        React.createElement(ValueRange, { iconSize: 'lg', arrowClassName: "pb-0", firstValue: React.createElement(Text, { type: "listItem" }, (_a = formatDate(obdobi === null || obdobi === void 0 ? void 0 : obdobi.terminOd)) !== null && _a !== void 0 ? _a : '-'), secondValue: React.createElement(Text, { type: "listItem" }, (_b = formatDate(obdobi === null || obdobi === void 0 ? void 0 : obdobi.terminDo)) !== null && _b !== void 0 ? _b : '-') })));
};
//# sourceMappingURL=EtapaDetail.js.map